 <div *ngIf="section1">
   <div mat-dialog-title>
     <div class="d-flex justify-content-between">
       <p>{{currentActionpage}}</p>
       <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
     </div>
   </div>
   <div mat-dialog-content>
     <div class="row eip-form-controls m-0 eip-mt-15 ">
       <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
         <div class="ng-autocomplete">
           <ng-autocomplete [data]="suggestionValue" [(ngModel)]="newDescription" [searchKeyword]="keyword"
             [placeholder]="currentPlaceHolder"   (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)'
             [itemTemplate]="itemTemplate">
           </ng-autocomplete>
           <ng-template #itemTemplate let-item>
             <a *ngIf="item.tE_Description" [innerHTML]="item.tE_Description"></a>
             <a *ngIf="item.tI_Description" [innerHTML]="item.tI_Description"></a>
           </ng-template>
         </div> 
       </div>
       <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 eip-mt-10">
         <div class="view-info eip-mb-20">
           <mat-label>Active Status:</mat-label>
           <div>
             <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [(ngModel)]="activeStatus" [disabled]="false"
               [checked]="true"></kendo-switch>
           </div>
         </div>
       </div>
     </div>

     <div mat-dialog-actions>
       <div class="row justify-content-end flex-grow-1">
         <button class="btn btn-primary" (click)="postData()">Save</button>
       </div>
     </div>
   </div>
 </div>

 <div *ngIf="section2">
   <div mat-dialog-title>
     <div class="d-flex justify-content-between">
       <p>{{currentActionpage}}</p>
       <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
     </div>
   </div>
   <div mat-dialog-content>
     <div class="row eip-form-controls m-0 eip-mt-15">
       <div [hidden]="show" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
         <dynamic-form #dynamicFormComponent [repeatCount]=1> </dynamic-form>
       </div>
       <div *ngIf="show == true"  class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">       
        <mat-form-field >
          <mat-label>Selected Discipline</mat-label>
          <input  matInput [(ngModel)]="editDiscipline"  [disabled]="show"/>
       </mat-form-field>
       </div>
      </div>


      <div   class="row eip-form-controls m-0 eip-mt-15 space">
        <div style="margin-top: 3%; padding-top: 2%;" class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-24">
          <div class="view-info eip-mb-20">
            <mat-form-field>
              <mat-select placeholder="Select Element" [disabled]="setDisable"  [(ngModel)]="elementId" matInput required>
                <mat-option *ngFor="let data of elementList"  [value]="data.tE_Id ">
                  {{ data.tE_Description }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>   
        <div   style ="width: 50%; float: right; margin-top: 3%; padding-top: 2%" > 
          <div style="width: 100%;" >
            <div class="view-info eip-mb-20">
              <mat-form-field>
                <mat-select placeholder="Select Item" [disabled]="setDisable" [(ngModel)]="itemId" matInput required>
                  <mat-option *ngFor="let data of itemList" [value]="data.tI_Id">
                    {{data.tI_Description}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
      </div>
    </div> 
       <div class="row eip-form-controls m-0 eip-mt-15">
       <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 eip-mt-10">
         <div class="view-info eip-mb-20">
           <mat-label>Active Status:</mat-label>
           <div>
             <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [(ngModel)]="activeStatus" [disabled]="false"
               [checked]="true"></kendo-switch>
           </div>
         </div>
       </div>
     </div>

     <div mat-dialog-actions>
       <div class="row justify-content-end flex-grow-1">
         <button   class="btn btn-primary" (click)="postData()">Save</button>
       </div>
     </div>
   </div>
 </div>
